module.exports = __webpack_public_path__ + "static/img/2.3ebf4cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/zh/2.png
// module id = OSgH
// module chunks = 0